module.exports = __webpack_public_path__ + "static/media/SAF-Regular-01.6f2abb9e.svg";